import { render, staticRenderFns } from "./r-tip.vue?vue&type=template&id=829bc49e&scoped=true&"
import script from "./r-tip.vue?vue&type=script&setup=true&lang=js&"
export * from "./r-tip.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./r-tip.vue?vue&type=style&index=0&id=829bc49e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829bc49e",
  null
  
)

export default component.exports